module.exports = __webpack_public_path__ + "static/media/actions.88ab2b2a.svg";